import {
  type AccountStatus,
  type AccountStatusSource,
  deriveAccountStatus,
} from '@repo/api-contracts';
import type { StatusTone } from '@/shared/ui';

interface DisplayStatus {
  readonly label: string;
  readonly className: string;
  /** 상태 배지 색조 — 정상은 positive, 차단은 danger, 탈퇴는 neutral. */
  readonly tone: StatusTone;
}

/**
 * 계정 상태별 목록 표시 라벨. 상태 파생은 계약의 deriveAccountStatus 단일 구현을
 * 쓴다 — 우선순위 판정을 클라이언트에서 재구현하지 않는다.
 */
const STATUS_DISPLAY: Record<AccountStatus, DisplayStatus> = {
  DELETED: { label: '탈퇴', className: 'text-muted-foreground', tone: 'neutral' },
  BLOCKED: { label: '차단됨', className: 'text-destructive', tone: 'danger' },
  PENDING_EMAIL: { label: '정상', className: 'text-foreground', tone: 'positive' },
  PENDING_IDENTITY: { label: '정상', className: 'text-foreground', tone: 'positive' },
  ACTIVE: { label: '정상', className: 'text-foreground', tone: 'positive' },
};

export const displayStatus = (status: AccountStatus): DisplayStatus => STATUS_DISPLAY[status];

/**
 * 계정 필드에서 바로 표시 라벨을 얻는다 — 어드민에서 상태를 파생하는 유일한 자리다(목록 행·회원 상세가 함께 쓴다).
 *
 * 어드민 라벨은 PENDING_IDENTITY 와 ACTIVE 가 모두 '정상'이라 본인인증 사용 여부와 결과가 같다 —
 * 서버 설정을 따로 조회하지 않고 identityRequired 를 true 로 둔다.
 */
export const displayAccountStatus = (user: AccountStatusSource): DisplayStatus =>
  displayStatus(deriveAccountStatus(user, { identityRequired: true }));
